import React from 'react';
import {
    GOOGLE_CHANNEL, FACEBOOK_CHANNEL, TIKTOK_CHANNEL, LINKEDIN_CHANNEL,
    ANALYTICS_CHANNEL, SHEET_CHANNEL, SHOPIFY_CHANNEL, TIENDA_NUBE_CHANNEL,
    WOOCOMMERCE_CHANNEL, VTEX_CHANNEL,
} from '../channels/channels';

export const LEVEL_COLORS = {
    good: 'var(--portal-good)',
    normal: 'var(--portal-info)',
    bad: 'var(--portal-warning)',
    critic: 'var(--portal-critical)',
};

export const CHANNEL_BOOLEAN_MAP = [
    {field: 'has_google_channel', channel: GOOGLE_CHANNEL},
    {field: 'has_facebook_channel', channel: FACEBOOK_CHANNEL},
    {field: 'has_tiktok_channel', channel: TIKTOK_CHANNEL},
    {field: 'has_linkedin_channel', channel: LINKEDIN_CHANNEL},
    {field: 'has_analytics_channel', channel: ANALYTICS_CHANNEL},
    {field: 'has_sheet_channel', channel: SHEET_CHANNEL},
    {field: 'has_shopify_channel', channel: SHOPIFY_CHANNEL},
    {field: 'has_tienda_nube_channel', channel: TIENDA_NUBE_CHANNEL},
    {field: 'has_woocommerce_channel', channel: WOOCOMMERCE_CHANNEL},
    {field: 'has_vtex_channel', channel: VTEX_CHANNEL},
];

export function getTodayAlert(columnData) {
    if (!columnData?.alerts_by_day) return null;
    const days = Object.keys(columnData.alerts_by_day);
    if (days.length === 0) return null;
    const lastDay = Math.max(...days.map(Number));
    return columnData.alerts_by_day[lastDay];
}

export const IndicatorBadge = ({alert}) => {
    if (!alert) return null;
    // El backend devuelve `level` y `fluctuation` en MAY\u00daSCULAS dentro de alerts_by_day
    // (el Tablero general normaliza con `.toLowerCase()` antes de usarlos como clase CSS).
    // Normalizamos ac\u00e1 para que LEVEL_COLORS y las flechas matcheen.
    const level = String(alert.level || '').toLowerCase();
    const fluctuation = String(alert.fluctuation || '').toLowerCase();
    const color = LEVEL_COLORS[level] || LEVEL_COLORS.normal;
    const arrow = (fluctuation === 'over' || fluctuation === 'up') ? '\u2191'
        : (fluctuation === 'under' || fluctuation === 'down') ? '\u2193' : '';

    let pct = '';
    if (alert.fluctuation_percentage != null) {
        const cleaned = String(alert.fluctuation_percentage).replace(/%/g, '').trim();
        if (cleaned && !/^-+$/.test(cleaned)) {
            pct = `${cleaned}%`;
        }
    }

    if (!pct && !arrow) return null;

    return (
        <span className="portal-indicator-badge" style={{backgroundColor: color}}>
            {pct} {arrow}
        </span>
    );
};

export const BudgetProgressBar = ({cost, budget}) => {
    if (!budget || budget <= 0) return null;
    const rawPct = Math.round((cost / budget) * 100);
    const isOverBudget = rawPct > 100;
    const displayPct = rawPct;
    const fillPct = Math.min(rawPct, 100);

    let color = 'var(--portal-good)';
    if (rawPct >= 100) color = 'var(--portal-critical)';
    else if (rawPct >= 80) color = 'var(--portal-warning)';

    return (
        <div className={`portal-hero-progress${isOverBudget ? ' -over-budget' : ''}`}>
            <div className="portal-hero-progress-track">
                <div
                    className="portal-hero-progress-fill"
                    style={{width: `${fillPct}%`, backgroundColor: color}}
                />
            </div>
            <span
                className="portal-hero-progress-label"
                style={isOverBudget ? {color: 'var(--portal-critical)'} : undefined}
            >
                {displayPct}%
            </span>
        </div>
    );
};

export const SemaphoreIndicator = ({level}) => {
    // level puede venir en MAYÚSCULAS (alerts_by_day del backend) — normalizamos.
    const color = LEVEL_COLORS[String(level || '').toLowerCase()] || LEVEL_COLORS.normal;
    return (
        <span className="portal-bu-semaphore" style={{backgroundColor: color}} />
    );
};

export const formatCurrency = (value) => {
    if (value >= 1000000) return `$${(value / 1000000).toFixed(1)}M`;
    if (value >= 1000) return `$${(value / 1000).toFixed(1)}K`;
    return `$${Math.round(value).toLocaleString()}`;
};
